<script>
    // -- IMPORTS

    import { getLocalizedText } from 'senselogic-gist';
    import AnimatedText from '../element/AnimatedText.svelte';
    import { languageTagStore } from '../../store/languageTagStore';
    import { getProcessedMultilineTranslatedText } from '$src/lib/base';
    import Button from '../element/Button.svelte';
    import { enabledAdminView } from '$src/lib/store/adminStore';

    // -- VARIABLES

    /** @type {{block?: any}} */
    let { block = $bindable({}) } = $props();
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- CLASSES

    .page-heading
    {
        min-width: 100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2.5rem;
    }

    .page-heading-title,
    .page-heading-subtitle
    {
        width: 90%;

        line-height: 2.5rem;
        font-size: 2rem;
        font-weight: 400;
        letter-spacing: 0.16rem;
        text-align: left;
        text-transform: none;

        +media( desktop )
        {
            line-height: 7.5rem;
            font-size: 6rem;
            font-weight: 250;
            letter-spacing: 0.48rem;
            text-align: center;
        }
    }

    .page-heading-subtitle
    {
        line-height: 2.25rem;
        font-size: 1.5rem;
        font-weight: 400;
        text-align: left;

        +media( desktop )
        {
            line-height: 2.25rem;
            font-size: 1.5rem;
            letter-spacing: 0.03rem;
            text-align: center;
        }
    }

    .page-heading-text
    {
        width: 90%;
        height: 100%;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        font-size: 16px;
        line-height: 24px;
        text-align: center;
    }
</style>

<div class="page-heading" class:is-admin-enabled={ $enabledAdminView }>
    {#if block.title}
        <h1 class="page-heading-title color-light-gold">
            <AnimatedText text={ getLocalizedText( block.title, $languageTagStore ) } />
        </h1>
    {/if}

    {#if block.imageLegend}
        <h6 class="page-heading-subtitle color-light-grey">
            <AnimatedText text={ getProcessedMultilineTranslatedText( block.imageLegend, $languageTagStore ) } />
        </h6>
    {/if}

    {#if block.text}
        <p class="page-heading-text font-size-150 font-weight-500 color-gray">
            <AnimatedText text={ getProcessedMultilineTranslatedText( block.text, $languageTagStore ) } />
        </p>
    {/if}

    {#if block.teaser && block.href}
        <Button href={ block.href } style="letter-spacing: 1.5px;" target="_blank">
            { getLocalizedText( block.teaser, $languageTagStore ) }
        </Button>
    {/if}
</div>